// d3VisualEffects.js
import * as d3 from 'd3';
export const setupShimmerEffects = (svg) => {
    const defs = svg.select("defs");
    if (defs.empty()) {
        svg.append("defs");
    }

    // Remove any existing gradients and filters
    svg.select("defs").selectAll(".shimmer-gradient, #glow, #text-glow").remove();

    // Shimmer gradient (keep as is)
    svg.select("defs")
        .append("linearGradient")
        .attr("class", "shimmer-gradient")
        .attr("id", "shimmer-gradient")
        .attr("x1", "0%")
        .attr("y1", "0%")
        .attr("x2", "200%")
        .attr("y2", "0%")
        .attr("gradientUnits", "userSpaceOnUse")
        .selectAll("stop")
        .data([
            { offset: "0%", color: "rgba(24, 119, 242, 0)" },
            { offset: "40%", color: "rgba(24, 119, 242, 0.4)" },
            { offset: "50%", color: "rgba(24, 119, 242, 0.8)" },
            { offset: "60%", color: "rgba(24, 119, 242, 0.4)" },
            { offset: "100%", color: "rgba(24, 119, 242, 0)" }
        ])
        .enter()
        .append("stop")
        .attr("offset", d => d.offset)
        .attr("stop-color", d => d.color);

    // Strong glow for shapes
    const shapeGlow = svg.select("defs")
        .append("filter")
        .attr("id", "glow")
        .attr("x", "-50%")
        .attr("y", "-50%")
        .attr("width", "200%")
        .attr("height", "200%");

    shapeGlow.append("feGaussianBlur")
        .attr("stdDeviation", "4")
        .attr("result", "coloredBlur");

    const shapeGlowMerge = shapeGlow.append("feMerge");
    shapeGlowMerge.append("feMergeNode")
        .attr("in", "coloredBlur");
    shapeGlowMerge.append("feMergeNode")
        .attr("in", "SourceGraphic");

    // Subtle white glow for text
    const textGlow = svg.select("defs")
        .append("filter")
        .attr("id", "text-glow")
        .attr("x", "-50%")
        .attr("y", "-50%")
        .attr("width", "200%")
        .attr("height", "200%");

    // White glow background for contrast
    textGlow.append("feGaussianBlur")
        .attr("stdDeviation", "2")
        .attr("result", "whiteBlur");

    textGlow.append("feFlood")
        .attr("flood-color", "white")
        .attr("result", "white");

    textGlow.append("feComposite")
        .attr("in", "white")
        .attr("in2", "whiteBlur")
        .attr("operator", "in")
        .attr("result", "whiteGlow");

    const textGlowMerge = textGlow.append("feMerge");
    textGlowMerge.append("feMergeNode")
        .attr("in", "whiteGlow");
    textGlowMerge.append("feMergeNode")
        .attr("in", "SourceGraphic");
};

export const updateNodeShimmer = (node, d, isShimmerActive) => {
    if (isShimmerActive) {
        if (d.type === 'model') {
            node.select('circle')
                .style('stroke', '#1877f2')
                .style('stroke-width', '8px')
                .style('filter', 'url(#glow)')
                .style('stroke', 'url(#shimmer-gradient)');

            // Keep circle pulsing
            node.select('circle')
                .transition()
                .duration(1000)
                .attr('r', function() {
                    const baseRadius = this.getAttribute('r');
                    return parseFloat(baseRadius) + 5;
                })
                .transition()
                .duration(1000)
                .attr('r', function() {
                    const baseRadius = this.getAttribute('r');
                    return parseFloat(baseRadius);
                })
                .on("end", function() {
                    if (isShimmerActive) {
                        d3.select(this).call(function() {
                            updateNodeShimmer(node, d, true);
                        });
                    }
                });
        } else {
            // Evidence rectangle
            node.select('rect')
                .style('stroke', '#1877f2')
                .style('stroke-width', '8px')
                .style('filter', 'url(#glow)')
                .style('stroke', 'url(#shimmer-gradient)');

            // Rectangle pulse
            node.select('rect')
                .transition()
                .duration(1000)
                .style('transform', 'scale(1.1)')
                .transition()
                .duration(1000)
                .style('transform', 'scale(1)')
                .on("end", function() {
                    if (isShimmerActive) {
                        d3.select(this).call(function() {
                            updateNodeShimmer(node, d, true);
                        });
                    }
                });
        }

        // Enhanced text visibility during shimmer
        node.select('text')
            .style('fill', '#000000') // Keep text dark
            .style('filter', 'url(#text-glow)') // Add white glow around text
            .style('font-weight', '600'); // Slightly bolder than normal

    } else {
        // Reset styles when inactive
        if (d.type === 'model') {
            node.select('circle')
                .style('stroke', null)
                .style('stroke-width', null)
                .style('filter', null)
                .interrupt();
        } else {
            node.select('rect')
                .style('stroke', null)
                .style('stroke-width', null)
                .style('filter', null)
                .style('transform', null)
                .interrupt();
        }

        // Reset text styles
        node.select('text')
            .style('fill', null)
            .style('font-weight', null)
            .style('filter', null);
    }
};